module.exports = __webpack_public_path__ + "static/media/InvolvedXs2.6ee2dc9e.svg";